<template>
    <div class="app-background">
        <Header></Header>
        <router-view />
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'
export default {
    components: {
        Header, Footer
    },
}
</script>

<style lang="less" scoped>
.main-wrap {
    width: 100%;
    background-color: #f4f6fa;
}

.main-wrap2 {
    width: 100%;
    background-color: #fff;
}

.main {
    width: 1200px;
    margin: 0 auto;
    // padding: 50px 0;
}
</style>